<template>
  <div>
    <v-carousel hide-delimiter-background hide-delimiters cycle height="600" :show-arrows="false" interval="4000">
      <v-carousel-item v-for="(banner, index) in banners" :key="index">
        <v-img :src="banner.src" :alt="banner.alt" class="banner-image" />
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "ContactUsBanner",
  data() {
    return {
      banners: [
        { src: "/cover/34831.jpg", alt: "Contact Us Banner" },
      ],
    };
  },
};
</script>

<style scoped>
.banner-image {
  width: 100%;
  height: 600px;
  object-fit: cover;
  object-position: center;
  display: block;
}

.contact-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
  padding-top: 100px;
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .contact-section {
    max-width: 1200px;
  }
}

.contact-h1 {
  font-size: 40px;
  font-weight: 600;
}

.contact-h3 {
  font-size: 28px;
}

.contact-text {
  font-size: 16px;
}

@media (max-width: 768px) {
  .banner-image {
    height: 300px;
  }

  .contact-h1 {
    font-size: 18px;
  }

  .contact-h3 {
    font-size: 13px;
  }
}
</style>
